import { doc, updateDoc } from 'firebase/firestore';
import { firestore } from '~/firebase/init';
import { Customer } from '~/types/platform/customer';

export default async function updateCustomer(
  platformId: string,
  customerId: string,
  updateData: Partial<Customer>,
) {
  const ref = doc(firestore, 'platforms', platformId, 'customers', customerId);

  return updateDoc(ref, updateData);
}
